import { noop } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

const baseSettings = {
  member: false
};

type Settings = {
  [K in keyof typeof baseSettings]: any;
};

export const SettingContext = React.createContext<{
  setSetting: (key: keyof typeof baseSettings, content: any) => void;
  settings: Settings;
}>({ setSetting: noop, settings: baseSettings });

const STORAGE_KEY = 'aaa-app-setting';

export const getSettingFromStorage = () => {
  const value = (process as any).browser
    ? localStorage.getItem(STORAGE_KEY)
    : {};
  if (typeof value === 'string') {
    try {
      return JSON.parse(value) as Settings;
    } catch (err) {
      console.warn('failed to parse user from storage', value);
    }
  }
  return baseSettings;
};

export const SettingProvider: React.FC = ({ children }) => {
  const [settings, setSettings] = useState<Settings>(getSettingFromStorage());

  const handleSetSetting = useCallback(
    (key: keyof typeof baseSettings, content: any) => {
      if (content === null) {
        settings[key] = baseSettings[key];
      } else {
        settings[key] = content;
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
      setSettings({ ...settings });
    },
    [setSettings, settings]
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!settings.member && window.location.pathname === '/') {
        window.location.href = '/nonmember';
      } else if (
        settings.member &&
        (window.location.pathname === '/nonmember' ||
          window.location.pathname === '/nonmember/')
      ) {
        window.location.href = '/';
      }
    }
  }, [typeof window, settings]);

  return (
    <SettingContext.Provider value={{ setSetting: handleSetSetting, settings }}>
      {children}
    </SettingContext.Provider>
  );
};
